<template>
    <div class="jwplayer-video-container">
        <div id="jwplayer-video"></div>
    </div>
</template>

<script>
export default {
    name: "VideoPlayer",
    props: {
        videoToken: {
            type: String,
        },
        resumePosition: {
            type: Number,
            default: 0,
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        controls: {
            type: Boolean,
            default: true,
        },
        tracking: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            currentPosition: 0,
            positionInterval: null,
        };
    },
    mounted: function () {
        this.startVideo();
    },
    methods: {
        startVideo() {
            let vm = this;

            let player = window.jwplayer("jwplayer-video").setup({
                key: window.jwplayerKey,
                file:
                    "//content.jwplatform.com/manifests/" +
                    vm.videoToken +
                    ".m3u8",
                autostart: this.autoplay,
                displaytitle: false,
                mute: false,
                controls: this.controls,
                repeat: false,
                aspectratio: "16:9",
                height: "100%",
                width: "100%",
                stretching: "exact",
                position: 0,
            });

            window.onbeforeunload = this.onClose(
                Math.floor(player.getPosition())
            );

            player.play();
            if (this.tracking) {
                player.on("firstFrame", () => {
                    if (vm.resumePosition) {
                        player.seek(vm.resumePosition - 5);
                    }

                    player.pause();

                    vm.$emit("update-video-status", {
                        position: Math.floor(player.getPosition()),
                        status: "loaded",
                    });
                });

                player.on("time", function (callback) {
                    vm.currentPosition = callback.position;
                });

                player.on("play", function () {
                    vm.$emit("update-video-status", {
                        position: Math.floor(player.getPosition()),
                        status: "playing",
                    });

                    vm.positionInterval = setInterval(function () {
                        window.idleTimer = 0; // repeatedly reset the idle timer while video is actively playing
                        vm.$emit("update-video-status", {
                            position: Math.floor(player.getPosition()),
                            status: "playing",
                        });
                    }, 30 * 1000);
                });

                player.on("pause", function () {
                    clearInterval(vm.positionInterval);
                });

                // finsh video and submit
                player.on("complete", function () {
                    vm.$emit("update-video-status", {
                        position: Math.floor(player.getPosition()),
                        status: "completed",
                    });
                    clearInterval(vm.positionInterval);
                });
            }
        },
        onClose(position) {
            this.$emit("update-video-status", {
                position: Math.floor(position),
                status: "closed",
            });

            return null;
        },
    },
    watch: {
        videoToken(newValue, oldValue) {
            this.startVideo();
        },
    },
};
</script>
